// extracted by mini-css-extract-plugin
export default {"Modal":"Style_Modal__o6TPg","Cont":"Style_Cont__5qmAb"};